import React from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'

const size = 50

const StAddButton = styled.div`
  position: absolute;
  top: -15px;
  right: -15px;
  width: ${size}px;
  height: ${size}px;
  > .btn-bg {
    position: absolute;
    display: block;
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
      0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color),
      0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
      var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    width: ${size}px;
    height: ${size}px;
    border-radius: ${size}px;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
    }
  }
`

const AddButton = () => {
  const [{ y, backgroundColor }, set] = useSpring(() => ({
    y: 100,
    backgroundColor: '#fff',
  }))

  return (
    <StAddButton
      onMouseEnter={() => set({ y: 0, backgroundColor: '#477bf5' })}
      onMouseLeave={() => set({ y: 100, backgroundColor: '#fff' })}>
      <animated.div className="btn-bg" style={{ backgroundColor }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size - 26}
          height={size - 26}
          viewBox="0 0 24 24">
          <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />
        </svg>
      </animated.div>
    </StAddButton>
  )
}

export default AddButton
